module.exports = __webpack_public_path__ + "img/gzh.49b05ca4.jpg";